import { Controller } from "@hotwired/stimulus"

// Automatically resizes textarea elements to fit their content
export default class extends Controller {
  connect() {
    this.minRows = parseInt(this.element.getAttribute('rows')) || 3
    this.boundResize = this.resize.bind(this)
    this.element.addEventListener('input', this.boundResize)

    // Initial resize - use requestAnimationFrame to ensure styles are computed
    requestAnimationFrame(() => {
      this.resize()
    })

    // Also resize when element becomes visible (e.g., when parent is shown)
    this.observer = new MutationObserver(() => {
      if (this.isVisible()) {
        this.resize()
      }
    })

    // Observe ancestors for class changes (hidden -> visible)
    const parent = this.element.closest('[data-checkout-edit]')
    if (parent) {
      this.observer.observe(parent, { attributes: true, attributeFilter: ['class'] })
    }
  }

  disconnect() {
    this.element.removeEventListener('input', this.boundResize)
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  resize() {
    const element = this.element

    // Skip if element is not visible
    if (!this.isVisible()) return

    const lineHeight = parseFloat(getComputedStyle(element).lineHeight)
    const minHeight = this.minRows * lineHeight

    element.style.height = 'auto'
    const newHeight = Math.max(element.scrollHeight, minHeight) + 2
    element.style.height = `${newHeight}px`
  }

  isVisible() {
    return this.element.offsetParent !== null
  }
}
